<template>
  <div
    :class="[
      'd-flex padding-16',
      isMobileApp ? 'flex-column align-center' : 'justify-center align-center'
    ]"
  >
    <div :class="['d-inline-flex', isMobileApp ? 'flex-column align-center' : '']">
      <div :class="['calendar', isMobileApp ? 'text-center mb-4 calendar-mobile' : 'mr-8']">
        <div class="d-flex justify-space-between mb-2">
          <button class="control bg-grey rounded-lg wh40 font-weight-bold" @click="prevMonth">
            &lt;
          </button>
          <h4 class="mt-1">{{ currentMonth }}</h4>
          <button class="control bg-grey rounded-lg wh40 font-weight-bold" @click="nextMonth">
            &gt;
          </button>
        </div>
        <div class="weekdays d-flex">
          <span v-for="day in mondayFirstDays" :key="day" class="weekday">
            {{ day }}
          </span>
        </div>
        <div class="days-grid">
          <span
            v-for="(day, i) in daysInMonth"
            :key="day.date || `pad-${i}`"
            class="d-flex cursor-pointer rounded-circle align-center justify-center text-center wh40 margin-5px"
            :class="{
              'grey-darken--text cursor-not-allowed': day.__pad || !day.isFree,
              'black--text font--bold border-primary':
                !!day.date && !!selectedDate && day.date === selectedDate
            }"
            @click="!day.__pad && selectDate(day)"
          >
            {{ day.day || '' }}
          </span>
        </div>
      </div>
      <div
        v-if="availableTimes.length"
        :class="[
          'align-self-center text-center padding-16 time-selection pr-1',
          isMobileApp ? 'w-100 time-selection-mobile' : ''
        ]"
      >
        <h4 class="mb-6 text-center">{{ $t('videocall.chooseDate') }}</h4>
        <ul class="px-0 time-container pr-2">
          <li
            v-for="time in availableTimes"
            :key="time"
            class="cursor-pointer rounded-lg px-2 py-2 mb-1"
            :class="{ 'border-primary font-weight-bold black--text': time === selectedTime }"
            @click="selectTime(time)"
          >
            {{ time }}
          </li>
        </ul>
        <SendButton
          width="233px"
          :button-text="$t('videocall.confirmReservation')"
          :button-text-loading="$t('videocall.reservationProgressing')"
          :loading="buttonLoading"
          :disabled="buttonDisabled"
          class="mb-3 mt-1 rounded-lg"
          color="primary"
          @click="confirmSelection"
        />
      </div>
    </div>
  </div>
</template>

<script>
import appointeddVideoCall from '@/mixins/appointeddVideoCall.js';

export default {
  name: 'VideoCallCalendar',
  mixins: [appointeddVideoCall],
  computed: {
    mondayFirstDays() {
      const days = this.$t('videocall.dayOfWeek');
      if (!Array.isArray(days)) {
        return days;
      }
      return [...days.slice(1), days[0]];
    }
  }
};
</script>

<style scoped lang="scss">
.border-primary {
  border: 2px solid #3ca091;
}
.padding-16 {
  padding: 18px;
}
.calendar {
  width: 400px;
  padding: 12px;
}
.calendar.calendar-mobile {
  width: 320px;
  margin: 0 auto;
}
.calendar-mobile .days-grid {
  grid-template-columns: repeat(7, minmax(32px, 1fr));
  justify-content: center;
  overflow-x: hidden;
}

.time-selection {
  width: 250px;
}
.time-selection.time-selection-mobile {
  width: 300px;
}
.bg-primary {
  background-color: #3ca091;
}
.bg-grey {
  background-color: #d3d3d3;
}
.wh40 {
  width: 40px;
  height: 40px;
}
.margin-5px {
  margin: 5px;
}
.weekdays,
.days {
  flex-wrap: wrap;
  justify-content: space-around;
  display: flex;
}
.weekdays .weekday {
  width: calc(100% / 7);
  text-align: center;
  font-weight: bold;
  margin-bottom: 10px;
}
.days-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 5px;
  justify-items: center;
}
ul.time-container {
  max-height: 225px;
  overflow-y: auto;
  scroll-margin: 8px;
  margin: 0;
}
li {
  background-color: #f0f0f0;
}
</style>
